import { render, staticRenderFns } from "./FindOpponent.vue?vue&type=template&id=0633dd77&scoped=true&lang=pug&"
import script from "./FindOpponent.vue?vue&type=script&lang=js&"
export * from "./FindOpponent.vue?vue&type=script&lang=js&"
import style0 from "./FindOpponent.vue?vue&type=style&index=0&id=0633dd77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633dd77",
  null
  
)

export default component.exports